package com.appcreator.blueprint.core

import kotlinx.serialization.Serializable

@Serializable
data class ScreenPath(
    val value: String,
    val defaultParameters: Map<String, String>? = null
)
